import React from "react";
const PrescriptionTab = () => {
  return (
    <div className="PrescriptionTab">
      <p>Prescription Tab!! Hurray!!</p>
    </div>
  );
};
export default PrescriptionTab;


// WEBPACK FOOTER //
// ./src/component/dashboard/AllTabs/PrescriptionTab.js